import Vue from "vue"

import resetMixin from "~/mixins/store/resetToInitialState"

const initialState = function () {
  return {
    id: 0,
    value: 0,
    code: "",
    is_percentage: false,
  }
}

export const state = initialState

export const mutations = {
  SET: function (state, patch) {
    for (let key in patch) {
      if (typeof state[key] === typeof patch[key])
        Vue.set(state, key, patch[key])
    }
  },
  ...resetMixin.mutations,
}

export const actions = {
  PROBE: async function ({ state, commit, dispatch, getters }, code) {
    return new Promise((resolve, reject) => {
      if (code !== state.code) {
        this.$axios
          .$post("/wallet/promo/", {
            code,
          })
          .then((response) => {
            commit("SET", response)
            if (!getters.IS_VALID_PERCENT) reject("Percent not valid")
            else
              dispatch("draft/UPDATE", undefined, { root: true }).then(() => {
                resolve()
              })
          })
          .catch((err) => {
            dispatch("RESET").finally(() => {
              reject(err)
            })
            reject(err)
          })
      } else if (getters.IS_VALID_PERCENT) resolve()
      else reject("Percent not valid")
    })
  },
  RESET: function ({ commit, dispatch, rootState }) {
    return new Promise((resolve, reject) => {
      this.$axios
        .$patch(`/submission/draft/${rootState.draft.id}/`, { promo: null })
        .then(() => {
          commit("RESET", initialState())
          resolve()
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
}

export const getters = {
  TO_REMOVE: function (state, getters, rootState, rootGetters) {
    const base_cost = rootGetters["cart/COST"]

    if (state.id > 0 && getters.IS_VALID_PERCENT) {
      if (state.is_percentage)
        return Math.round(Number(base_cost * state.value) / 100)
      else return Math.min(state.value, base_cost)
    } else return 0
  },
  CART_COST: function (state, getters, rootState, rootGetters) {
    const base_cost = rootGetters["cart/COST"]

    if (state.id > 0) return base_cost - getters["TO_REMOVE"]
    else return base_cost
  },
  IS_VALID_PERCENT: function (state, getters, rootState, rootGetters) {
    if (state.id > 0 && state.is_percentage)
      return rootGetters["cart/COST"] >= Math.round(100 / state.value)
    else return true
  },
}
